import DataSource from './DataSource';
import DataModel from './DataModel';
import { numbersSorter } from './utils';

const DataAttributes = ['id', 'name', 'country_id', 'address', 'phones', 'email', 'breed_ids', 'fci_groups' ];
const Defaults = {
  id: '',
  name: '',
  country_id: 0,
  address: '',
  phones: '',
  email: '',
};

export default class Expert extends DataModel {
  static Defaults = Defaults;
  static DataAttributes = DataAttributes;
  static resource = DataSource.getSource('experts', 'experts{/:id}{/:action}.json', 'expert');

  constructor(data) {
    super(data);
    this.updateFrom({...this.constructor.Defaults, ...data});
    if (this.fci_groups && typeof(this.fci_groups) === 'object' && this.fci_groups.length) {
      this.fci_groups = this.fci_groups.map(item => parseInt(item)).sort(numbersSorter);
    } else {
      this.fci_groups = [];
    }
  }

  static withShowBreeds(id, show_id) {
    return this.resource.get(id, {action: 'breeds_by_show', show_id }).then((data) => {
      return new Expert(data);
    })
  }

  static withRingReports(id, show_id) {
    return this.resource.get(id, {action: 'ring_reports', show_id }).then((data) => {
      return new Expert(data);
    })
  }

  saveSortedBreedIds() {
    const patch = {id: this.id, sorted_breed_ids: this.sortedBreedIds, show_id: this.showId};
    return this.constructor.resource.update(patch).then(data => new this.constructor(data));
  }

  fullAddress() {
    return [this.country_name, this.address, this.phones].filter(item => item && item.trim() > '').join(', ');
  }


}

